import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import "core-js/modules/es6.regexp.split";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { asTree } from 'prismic-richtext';
import { NODE_ELEMENTS } from './RichTextConst';

var getNodeName = function getNodeName(_ref) {
  var type = _ref.type;
  return NODE_ELEMENTS[type] || null;
};

var getAttributes = function getAttributes(arg) {
  return {
    attrs: {
      href: arg.url
    }
  };
};

var getClasses = function getClasses(arg, cls) {
  return {
    class: [arg.label, cls]
  };
};

var getProps = function getProps(_ref2, _ref3) {
  var _ref2$element$data = _ref2.element.data,
      data = _ref2$element$data === void 0 ? {} : _ref2$element$data;
  var cls = _ref3.cls;
  return _objectSpread({}, getAttributes(data), getClasses(data, cls));
};

export default {
  functional: true,
  props: {
    payload: {
      type: Array,
      required: true
    },
    cls: {
      type: String,
      default: ''
    }
  },
  render: function render(h, _ref4) {
    var props = _ref4.props;

    var reducer = function reducer(acc, text, idx) {
      if (idx > 0) {
        acc.push(h('br'));
      }

      acc.push(text);
      return acc;
    };

    var injectBR = function injectBR(text) {
      return text.split('\n').reduce(reducer, []);
    };

    var elementBuilder = function elementBuilder(node) {
      var NodeName = getNodeName(node);

      if (NodeName == null) {
        return injectBR(node.text);
      }

      return h(NodeName, _mergeJSXProps([{}, getProps(node, props)]), [node.children.length > 0 ? node.children.map(elementBuilder) : injectBR(node.text)]);
    };

    return asTree(props.payload).children.map(elementBuilder);
  }
};